<template>
    <!-- Main Content -->
    <div class="main-container" :class="{ 'nav-open': isSidebarOpen }">
        <!-- Left Side Content (Categories and Food Items) -->
        <div class="left-side-container">
            <!-- Header -->
            <AppHeader @open-current-order-cart="toggleCurrentOrderCart(true)" />

            <div class="left-side-content-container">
                <!-- Sidebar -->
                <AppSidebar :is-open="isSidebarOpen" />
                <div class="left-side-main-content">
                    <h2 class="active-menu-title">{{ t('settings') }}</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import AppHeader from '@/components/base/appHeader.vue';
import AppSidebar from '@/components/base/appSidebar.vue';
import { useSystemSettingsStore } from '@/stores/systemSettings';

const { t } = useI18n();

const { getSidebarState } = useSystemSettingsStore();

const isSidebarOpen = computed(() => getSidebarState());
</script>